/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController, ViewWillEnter } from '@ionic/angular';
import { ActionButtonConfig } from 'src/app/models/action-button-config.model';
import { MenuTagModel } from 'src/app/models/menu-tag.model';
import { RegisterCode } from 'src/app/models/register-code.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { AuthService } from 'src/app/services/auth.service';
import { ChatService } from 'src/app/services/chat.service';
import { DataService } from 'src/app/services/data.service';
import { GetTranslationService } from 'src/app/services/get-translation.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit, ViewWillEnter {
  @Input() isModal = false;
  @Output() loggedIn: EventEmitter<boolean> = new EventEmitter<boolean>();

  registerCodeParam: string;
  registerParamForm: RegisterCode;
  registerForm: FormGroup = null;
  loginForm: FormGroup = null;

  loginDisplay = false;
  forgetPassword = false;
  didInit = false;
  processing = false;

  fbGroupObject: any = {};
  regAuthType = this.dataServ.rData.register_auth_type;

  userLang = localStorage.getItem('lang') || 'tr';
  redirectParam = this.activatedRoute.snapshot.queryParams['redirect'];
  maxDate = new Date().getFullYear() + 1;
  minDate = new Date().getFullYear() - 2;

  hidePreferences = false;
  appHotelsTags: MenuTagModel[] = [];
  myProfileConfig: ActionButtonConfig[] = [];
  openMyProfile: boolean = false;
  deleteMyProfile: boolean = false;
  liveSupportName: string = 'My Assistance';
  constructor(
    public authServ: AuthService,
    public dataServ: DataService,
    private fb: FormBuilder,
    public chatServ: ChatService,
    public modalServ: ModalMakerService,
    private activatedRoute: ActivatedRoute,
    public caption: CaptionPipe,
    private router: Router,
    private modalCtrl: ModalController,
    private titleService: Title,
    private alertCtrl: AlertController,
    private translation: GetTranslationService
  ) {}

  async ngOnInit() {
    // https://hiltondalaman.guestservice.app/profile?open_my_profile=true
    this.openMyProfile =
      this.activatedRoute.snapshot.queryParams['open_my_profile'];
    // https://hiltondalaman.guestservice.app/profile?delete_my_profile=true
    this.deleteMyProfile =
      this.activatedRoute.snapshot.queryParams['delete_my_profile'];
    // https://hiltondalaman.guestservice.app/profile?register_token=1234567890
    this.authServ.registerToken =
      this.activatedRoute.snapshot.queryParams['register_token'];

    if (this.authServ.registerToken) {
      try {
        await this.authServ.postWithToken();
        this.authServ.control();
        await this.authServ.getMe();
      } catch (error) {}
    }
    if (this.openMyProfile && this.authServ.isLogged) {
      this.modalServ.myProfile('account');
    }
    if (this.deleteMyProfile && this.authServ.isLogged) {
      await this.showDeleteAccountConfirmation();
    }

    if (this.regAuthType && this.regAuthType === 'disable_authentication') {
      this.router.navigateByUrl('/home');
      return;
    }

    this.myProfileConfig = this.dataServ.rData.action_buttons?.filter(
      (x) => x.type === 'my_profile'
    );

    this.myProfileConfig.forEach((config) => {
      if (config.code === 'LiveSupport') {
        this.liveSupportName = config.name;
      }
    });

    if (this.authServ.isLogged) {
      this.appHotelsTags = await this.dataServ.getMenuTags(0, 'Apphotels Tags');

      if (this.appHotelsTags.length > 0) {
        this.appHotelsTags.forEach((tag) => {
          if (tag.name === 'hide-preferences') {
            this.hidePreferences = true;
          }
        });
      }
    }

    this.dataServ.rData.register_by_module_page_field_setup.forEach((setup) => {
      const partValue = setup.control_part_value;
      const isRequired = setup.required;

      if (
        partValue === 'terms_and_conditions' ||
        partValue === 'privacy_policy'
      ) {
        if (partValue === 'terms_and_conditions' && isRequired) {
          this.fbGroupObject['terms_and_conditions'] = [
            false,
            [Validators.pattern('true')],
          ];
        } else if (partValue === 'privacy_policy' && isRequired) {
          this.fbGroupObject['privacy_policy'] = [
            false,
            [Validators.pattern('true')],
          ];
        } else {
          this.fbGroupObject[partValue] = [false];
        }
      } else if (partValue === 'email') {
        this.fbGroupObject[partValue] = ['', [Validators.email]];
      } else {
        this.fbGroupObject[partValue] = [''];
      }
    });

    this.registerCodeParam =
      this.activatedRoute.snapshot.queryParams['registerCode'];
    if (this.registerCodeParam) {
      this.registerParamForm = await this.dataServ.registerCode(
        this.registerCodeParam
      );
    }

    this.authServ.control();

    if (!this.authServ.isLogged) {
      this.registerForm = this.fb.group(this.fbGroupObject);

      this.loginForm = this.fb.group({
        // ALTINYUNUS
        username: ['', [Validators.required]],
        // ALTINYUNUS

        // username: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required]],
      });

      setTimeout(() => {
        this.didInit = true;

        setTimeout(() => {
          this.didInit = false;

          setTimeout(() => {
            this.didInit = true;
          }, 1600);
        }, 100);
      }, 200);
    } else {
      await this.authServ.getMe();
    }
  }

  async logout() {
    try {
      this.authServ.logOut();
      this.ngOnInit();
    } catch (error) {}
  }
  ionViewWillEnter(): void {
    this.titleService.setTitle('My Profile');
  }

  ionViewDidEnter() {
    if (this.regAuthType && this.regAuthType === 'disable_authentication') {
      this.router.navigateByUrl('/home');
      return;
    }

    if (this.regAuthType && this.regAuthType === 'guest_list_authentication') {
      this.loginDisplay = false;
      return;
    }

    this.redirectParam = this.activatedRoute.snapshot.queryParams['redirect'];

    if (this.redirectParam) {
      if (this.redirectParam === 'login') {
        this.loginDisplay = true;
      } else if (this.redirectParam === 'register') {
        this.loginDisplay = false;
      }
    }
  }
  ionViewDidLeave() {
    this.redirectParam = null;
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async register() {
    this.processing = true;
    try {
      await this.authServ.createUser(this.registerForm.value);
      this.authServ.control();
      await this.authServ.getMe();
      this.loggedIn.emit(true);
    } catch {}
    this.processing = false;
  }

  openLink(link: string) {
    const LINKLOCALE = this.caption.transform(link);
    this.modalServ.openLink(LINKLOCALE);
  }

  async sendPassword(email: string) {
    this.processing = true;

    try {
      this.authServ.forgotPassword(email);
      this.loginDisplay = true;
      this.forgetPassword = false;
    } catch {}

    this.processing = false;
  }

  async login() {
    this.processing = true;
    try {
      await this.authServ.login(this.loginForm.value);
      this.authServ.control();
      await this.authServ.getMe();
      this.loggedIn.emit(true);
    } catch {}
    this.processing = false;
  }

  getLoginFieldName(loginFieldControlPartValue: string) {
    switch (loginFieldControlPartValue) {
      case 'first_name':
        return 'Name';
      case 'last_name':
        return 'Surname';
      case 'email':
        return 'Email';
      case 'room_number':
        return 'Room No';
      case 'phone_no':
        return 'Phone Number';
      case 'passport_no':
        return 'Identity Number';
      default:
        return loginFieldControlPartValue;
    }
  }

  async showDeleteAccountConfirmation() {
    const MSG = await this.translation.getTranslate(
      'Hesabınızı silmek istiyor musunuz? Bu işlem geri alınamaz.'
    );
    const YES = await this.translation.getTranslate('Evet');
    const NO = await this.translation.getTranslate('Hayır');

    const ALERT = await this.alertCtrl.create({
      message: MSG,
      buttons: [
        {
          text: NO,
          role: 'cancel',
        },
        {
          text: YES,
          role: 'destructive',
          handler: async () => {
            try {
              await this.authServ.deleteMe();
              // Redirect to home after successful deletion
              this.router.navigateByUrl('/home');
            } catch (error) {
              console.error('Error deleting account:', error);
            }
          },
        },
      ],
    });

    await ALERT.present();
  }
}
